<script lang="ts">
	import { VERIVOX_LOGO_SRC } from '../utils/colorSchemes';

	export let compact = false;
</script>

<div class="verivox-logo-plate" class:verivox-logo-plate--compact={compact}>
	<img
		src={VERIVOX_LOGO_SRC}
		alt="Verivox"
		class="verivox-logo-plate__img"
		width={compact ? 72 : 96}
		height={compact ? 20 : 28}
	/>
</div>

<style>
	.verivox-logo-plate {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: #ffffff;
		border-radius: 10px;
		padding: 8px 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
		position: relative;
		z-index: 2;
		flex-shrink: 0;
	}

	.verivox-logo-plate--compact {
		border-radius: 8px;
		padding: 6px 10px;
	}

	.verivox-logo-plate__img {
		display: block;
		height: 28px;
		width: auto;
		max-width: 120px;
		object-fit: contain;
	}

	.verivox-logo-plate--compact .verivox-logo-plate__img {
		height: 20px;
		max-width: 96px;
	}
</style>
